import { Mutations } from "vuex-smart-module";
import { MutationTypes } from "../mutations-types";
import AuthState from "./state";
import { ITokenStatus } from "./models";

export default class AuthMutations extends Mutations<AuthState> {
  [MutationTypes.AUTH_REQUEST]() {
    this.state.status = "loading";
  }
  [MutationTypes.AUTH_SUCCESS]() {
    this.state.status = "success";
    this.state.authError = "";
    this.state.isConfirmed = false;
    this.state.tokenError = "";
  }
  [MutationTypes.AUTH_ERROR](err: any) {
    this.state.status = "error";
    this.state.authError = err;
    this.state.isConfirmed = false;
  }
  [MutationTypes.AUTH_LOGOUT]() {
    this.state.status = "";
    this.state.isConfirmed = false;
    this.state.authError = "";
  }
  [MutationTypes.CSRF_TOKEN_SET]() {
    this.state.csrfTokenEnabled = true;
  }
  [MutationTypes.HAS_TOKEN]() {
    this.state.hasToken = true;
  }
  [MutationTypes.TOKEN_STATUS](status: ITokenStatus) {
    this.state.tokenStatus = status;
  }
  [MutationTypes.VALIDATE_SUCCESS]() {
    this.state.isConfirmed = true;
  }
  [MutationTypes.VALIDATE_ERROR](error: any) {
    this.state.tokenError = error;
  }
  [MutationTypes.TOKEN_LOADED](loaded: boolean) {
    this.state.tokenLoaded = loaded;
  }
}
